import { createQueryKeys } from '@lukemorales/query-key-factory';

export const intelligence = createQueryKeys('intelligence', {
    portSuggestions: (orderId: string) => ({
        queryKey: [{ orderId }],
    }),
    offerSuggestions: (orderId: string) => ({
        queryKey: [{ orderId }],
    }),
});
